import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

window.renderFilters = (containerId, history, otherProps) => {
  ReactDOM.render(
    <App history={history} otherProps={{ ...otherProps, containerId }} />,
    document.getElementById(containerId),
  );
  serviceWorker.unregister();
};

window.unmountFilters = (containerId) => {
  ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
};

if (typeof window.mfe === 'undefined') {
  window.mfe = {};
}
if (typeof window.mfe.filter === 'undefined') {
  window.mfe.filter = {};
}
window.mfe.filter.git = GIT; // eslint-disable-line no-undef
window.mfe.filter.version = VERSION; // eslint-disable-line no-undef

if (!document.getElementById('Filters-container')) {
  ReactDOM.render(
    <React.StrictMode>
      <App standalone />
    </React.StrictMode>,
    document.getElementById('root'),
  );
  serviceWorker.unregister();
}
